import { render, staticRenderFns } from "./SingleSelectPerson.vue?vue&type=template&id=1e8d594c"
import script from "./SingleSelectPerson.vue?vue&type=script&lang=js"
export * from "./SingleSelectPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports